// extracted by mini-css-extract-plugin
export default {"inp_cat":"pluscat_inp_cat__OTW3r","add":"pluscat_add__FTkmN"};